/* eslint-disable no-undef */

(function() {
	if (window.__gpShopperLoaded) {
		return;
	}
	window.__gpShopperLoaded = true;

	const existingScript = document.querySelector('script[src*="player.vidvisor.io/core.js"], script[src*="gp-shopper-original.js"]');
	if (existingScript) {
		return;
	}
	
	const script = document.createElement('script');
	script.async = false;

	console.log("location hostname:", window.location.hostname);

	const domains = [
		"int.innosupps.com",
        "www.innosupps.com",
        "innosupps-japan.myshopify.com",
        "innosupps.jp",
        "www.innosupps.jp",
		"altrroot.com",
        "www.altrroot.com"
	];

	if (domains.includes(window.location.hostname)) {
		script.src = 'https://player.vidvisor.io/core.js';
	} else {
		script.src = 'https://shopper.ghostretail.com/gp-shopper-original.js';
	}

	document.addEventListener('DOMContentLoaded', () => {
		window.__gpShopperDOMContentLoaded = true;
	});

	script.onload = () => {
		if (window.__gpShopperDOMContentLoaded) {
			document.dispatchEvent(new Event('InitializeCore'));
		}
	};

	document.head.insertBefore(script, document.head.firstChild);
})();